// 1 2 3
// 4 5 6
// 7 8 9

import PIXIRenderer from '../../System/Render/PIXIRenderer';
import Game from '../../Game';
import { PopupID } from '../../State/UI/PopupID';
import { CheatsGui } from './CheatsGui';

export const CHEATS_GUI_ENABLED_STORAGE_KEY = 'cheatsGuiEnabled';

export class CheatsToggle {
    private readonly password: string = '321456987321478965'; // SG
    private value: string = '';
    private cheatsGui: CheatsGui | null = null;
    private isPointerDown: boolean = false;

    constructor() {
        if (window.localStorage?.getItem(CHEATS_GUI_ENABLED_STORAGE_KEY)) {
            this.toggleCheatsGui();
        }

        PIXIRenderer.renderer.plugins.interaction.on('pointermove', this.handlePointerMove);
        PIXIRenderer.renderer.plugins.interaction.on('pointerdown', this.handlePointerDown);
        PIXIRenderer.renderer.plugins.interaction.on('pointerup', this.handlePointerUp);
    }

    private isActive(): boolean {
        const state = Game.store.getState();
        return state.UIState.popupID === PopupID.SETTINGS_MENU;
    }

    private readonly handlePointerDown = (): void => {
        this.isPointerDown = true;
    };

    private readonly handlePointerUp = (): void => {
        this.isPointerDown = false;
    };

    private readonly handlePointerMove = (e: any): void => {
        if (!this.isPointerDown || !this.isActive()) return;

        const { x, y } = e.data.global;
        const colWidth = PIXIRenderer.renderer.screen.width / 3;
        const rowHeight = PIXIRenderer.renderer.screen.height / 3;
        const col = Math.floor(x / colWidth);
        const row = Math.floor(y / rowHeight);
        const n = row * 3 + col + 1;

        if (this.value.endsWith(`${n}`)) return;

        this.value = `${this.value}${n}`.slice(-this.password.length);

        if (this.value === this.password) {
            this.toggleCheatsGui();
        }
    };

    private toggleCheatsGui(): void {
        this.cheatsGui = this.cheatsGui || new CheatsGui();
        this.cheatsGui.toggle();
    }
}
